import { Deal } from "@mapmycustomers/shared/types/entity";

import { parseApiDateWithUtcTz } from "@app/util/parsers";

import customFieldsToFormValues from "./customFieldsToFormValues";
import type EditDealFormValues from "./EditDealFormValues";

// this type copied from antd
type RecursivePartial<T> = NonNullable<T> extends object
  ? {
      [P in keyof T]?: NonNullable<T[P]> extends (infer U)[]
        ? RecursivePartial<U>[]
        : NonNullable<T[P]> extends object
        ? RecursivePartial<T[P]>
        : T[P];
    }
  : T;

const dealToFormValues = (deal: Deal): RecursivePartial<EditDealFormValues> => ({
  amount: deal.amount,
  cadenceInterval: deal.cadenceInterval,
  closingDate: deal.closingDate ? parseApiDateWithUtcTz(deal.closingDate) : null,
  companyId: deal.account?.id,
  crmActivityTypeId: deal.crmActivityTypeId ?? undefined,
  customFields: customFieldsToFormValues(deal.customFields),
  dealLossComment: deal.dealLossComment,
  dealLossReasonId: deal.dealLossReason?.id,
  funnelId: deal.funnel.id,
  groups: new Set((deal.groups ?? []).map(({ id }) => id)),
  name: deal.name,
  personId: deal.contact?.id,
  score: deal.score,
  stageId: deal.stage.id,
  user: deal.user.id,
});

export default dealToFormValues;
